import React, { useState } from 'react';
import Accordion from '../../components/common/Accordion';

const CustomerUploadErrors = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const errors = [
    {
      category: "ヘッダー不足によるエラー (CF101)",
      description: "CSVファイルの1行目（ヘッダー）に必須の列名がない場合に表示されます。",
      items: [
        { title: "エラー：「必須のヘッダーが不足しています: name」", code: "CF101", content: "CSVファイルのヘッダーに name の列名が存在しません。必須項目のため、ヘッダーに列を追加してください。" },
        { title: "エラー：「必須のヘッダーが不足しています: email」", code: "CF101", content: "CSVファイルのヘッダーに email の列名が存在しません。必須項目のため、ヘッダーに列を追加してください。" }
      ]
    },
    {
      category: "データ内容によるエラー",
      description: "ヘッダーは正しくても、各行のデータの内容に問題がある場合に表示されます。",
      items: [
        {
          title: "エラー：「name は必須です」 (エラーコード: CV213)",
          code: "CV213",
          content: "原因：顧客情報CSVの必須項目であるname（顧客名）の列に、値が入力されていない行があります。 解決策：エラーメッセージに示された行番号を確認し、name列に顧客名を入力してください。"
        },
        {
          title: "エラー：「email が有効な形式ではありません」 (エラーコード: CV214)",
          code: "CV214",
          content: "原因：必須項目であるemailの列が空欄、またはメールアドレスとして無効な形式（例：@がない、ドメインが不正）の値が入力されています。 解決策：エラーメッセージに示された行番号を確認し、email列に正しい形式のメールアドレスを入力してください。"
        }
      ]
    }
  ];

  const filteredErrors = errors.map(category => ({
    ...category,
    items: category.items.filter(item => 
      item.title.toLowerCase().includes(searchTerm.toLowerCase()) || 
      item.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.content.toLowerCase().includes(searchTerm.toLowerCase())
    )
  })).filter(category => category.items.length > 0);

  return (
    <div className="bg-white p-8 w-full max-w-4xl mx-auto my-8 shadow-lg rounded-lg">
      <h1 className="text-3xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-gray-200">
        顧客CSVアップロードのエラー
      </h1>
      <p className="text-gray-600 mb-6">
        顧客CSVのアップロード処理中に発生したエラーの一覧です。エラーメッセージを元に、元のCSVファイルを修正してください。
      </p>

      {/* Search Box */}
      <div className="mb-8">
        <input
          type="text"
          placeholder="エラーコードやキーワードで検索..."
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {filteredErrors.length > 0 ? (
        filteredErrors.map((category, catIndex) => (
          <div key={catIndex} className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4 border-b pb-2">{category.category}</h2>
            <p className="text-gray-600 mb-6">{category.description}</p>
            {category.items.map((item, itemIndex) => (
              <Accordion key={itemIndex} title={item.title}>
                <div className="p-4">
                  {item.content.includes('原因：') ? (
                    <div className="space-y-4">
                      {item.content.split(' 解決策：').map((part, i) => (
                        <div key={i}>
                          <h4 className="font-semibold text-gray-700">{i === 0 ? '原因：' : '解決策：'}</h4>
                          <p className="text-gray-700 mt-1">{part.replace('原因：', '')}</p>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p>{item.content}</p>
                  )}
                </div>
              </Accordion>
            ))}
          </div>
        ))
      ) : (
        <p className="text-center text-gray-500 my-8">一致するエラーが見つかりませんでした。</p>
      )}
    </div>
  );
};

export default CustomerUploadErrors;
